import React from "react";

type DashboardCardProps = {
  title: string;
  value: number | string;
  color?: "blue" | "purple" | "green" | "red" | "yellow" | "default";
  icon?: React.ReactNode;
};

const colorClasses: Record<string, string> = {
  blue: "text-blue-600",
  purple: "text-purple-600",
  green: "text-green-600",
  red: "text-red-600",
  yellow: "text-yellow-600",
  default: "text-gray-800",
};

export default function DashboardCard({
  title,
  value,
  color = "default",
  icon,
}: DashboardCardProps) {
  const colorClass = colorClasses[color] || colorClasses.default;

  return (
    <div
      className="bg-white border border-gray-200 rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      tabIndex={0}
    >
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
          {title}
        </h2>
        {icon && <div className="ml-2 text-gray-400">{icon}</div>}
      </div>
      <p className={`mt-4 text-3xl font-extrabold ${colorClass}`}>{value}</p>
    </div>
  );
}
